module.exports = __webpack_public_path__ + "static/img/present_point_again_img.64204dec.gif";